import React from 'react';
import './styles.scss';

const Loader = ({ children, spinning }) => (
  <div className={`loading-container ${spinning ? 'is-loading' : ''}`}>
    <div className="loading-overlay"></div>
    {children}
    {<div className="crescent"></div>}
  </div>
);

export default Loader;
